// extracted by mini-css-extract-plugin
export default {"p_error":"styles_p_error__w-9Xj","a":"styles_a__CIrPN","error":"styles_error__ftTCm","transparent":"styles_transparent__cCBEI"};